var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            title: this.$t("CargoMsg.Cargo_NewSpaceCarrier"),
            "inline-message": "",
            width: _vm.isZh ? "1000px" : "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": _vm.isZh ? "80px" : "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 8, sm: 8, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.carrierType") } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "carrierType" },
                              on: { change: _vm.carrierTypeChangeHandler },
                              model: {
                                value: _vm.form.carrierType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "carrierType", $$v)
                                },
                                expression: "form.carrierType"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { no: "shippingCompany", label: 0 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                { attrs: { no: "airlineCompany", label: 1 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AirlineCompany"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: "",
                            label: _vm.$t("CargoMsg.Cargo_Contact")
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            attrs: { no: "contactName" },
                            model: {
                              value: _vm.form.contact,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "contact", $$v)
                              },
                              expression: "form.contact"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 8, sm: 8, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.bookingMethod") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: { no: "bookingMode" },
                              model: {
                                value: _vm.form.bookingMode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "bookingMode", $$v)
                                },
                                expression: "form.bookingMode"
                              }
                            },
                            _vm._l(_vm.bookingModes, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContactNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            attrs: { no: "contactNumber" },
                            model: {
                              value: _vm.form.contactNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "contactNumber", $$v)
                              },
                              expression: "form.contactNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 8, sm: 8, md: 8 } },
                    [_c("el-form-item")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_email") } },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            attrs: { no: "email" },
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.innerVisible
                ? _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Carrier"),
                            name: "carrierGroup"
                          }
                        },
                        [
                          _c("cabin-group-tab", {
                            ref: "carrier-group",
                            attrs: {
                              "detail-value": _vm.carrierDetailValue,
                              lob: _vm.form.lob,
                              status: _vm.innerStatus,
                              "group-name": "CARRIER"
                            },
                            on: { func: _vm.getDataFormCarrier }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading"),
                            name: "polGroup"
                          }
                        },
                        [
                          _c("cabin-group-tab", {
                            ref: "pol-group",
                            attrs: {
                              "detail-value": _vm.polDetailValue,
                              status: _vm.innerStatus,
                              lob: _vm.form.lob,
                              "is-need-change-port": _vm.isNeedChangePort,
                              "group-name": "POL"
                            },
                            on: { func: _vm.getDataFormPolGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_DestinationPort"),
                            name: "podGroup"
                          }
                        },
                        [
                          _c("cabin-group-tab", {
                            ref: "pod-group",
                            attrs: {
                              "detail-value": _vm.podDetailValue,
                              status: _vm.innerStatus,
                              lob: _vm.form.lob,
                              "is-need-change-port": _vm.isNeedChangePort,
                              "group-name": "POD"
                            },
                            on: { func: _vm.getDataFormPodGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_ShippingRouteArea"),
                            name: "saGroup"
                          }
                        },
                        [
                          _c("cabin-group-tab", {
                            ref: "sa-group",
                            attrs: {
                              "detail-value": _vm.saDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "REGION"
                            },
                            on: { func: _vm.getDataFormSa }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Country"),
                            name: "countryGroup"
                          }
                        },
                        [
                          _c("cabin-group-tab", {
                            ref: "country-group",
                            attrs: {
                              "detail-value": _vm.countryDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "COUNTRY"
                            },
                            on: { func: _vm.getDataFormCountry }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              { staticStyle: { "padding-right": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "confirm", type: "primary" },
                    on: { click: _vm.submitCabinCarrier }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }